<script lang="ts">
    import { onMount } from 'svelte'
    import DateSelect from '../_common/date-select.svelte'
    import Zact from '../_common/z/zact.svelte'
    import Zframe from '../_common/z/zframe.svelte'
    import dayjs from 'dayjs'
    import type { Service } from '../../modules/posApi/services/service'
    import LoadSpinner from '../_common/load-spinner.svelte'

    let show = false
    onMount(async () => {})

    async function goRecalc() {
        show = true
        try {
            const services: Service[] = await window.api.pos.services.getAll({ type: 'product' })
            for (const service of services) {
                await window.api.pos.services.recalculate(service.serviceId)
            }
            window.alert('Estoque recalculado com sucesso.')
        } catch (error) {
            window.error(error)
        } finally {
            show = false
        }
    }
</script>

<!-- <Zact>
    <div class="spacer" />
</Zact> -->

<Zframe class="h-space" title="Recalcular estoque" headline="Caso encontre uma inconsistência de seu estoque você pode solicitar um recálculo">
    <div class="grid-form">
        <div class="row">
            <div class="col">
                <button class="btn btn-primary" on:click={goRecalc}>Recalcular</button>
            </div>
        </div>
    </div>
</Zframe>
<LoadSpinner {show}></LoadSpinner>
